import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";

import "../css/style.css";

const Step40_Events = () => {

    const theEvent = JSON.parse(sessionStorage.getItem("SwissFinanceWeekEvent"));
    const remarks = JSON.parse(theEvent.remarks);
    const [orderId] = useState(sessionStorage.getItem("OrderId"));
    const [order, setOrder] = useState({});
    const orderAddress = JSON.parse(localStorage.getItem("addressBodySwissFitechWeek"));
    const [bookedTickets, setBookedTickets] = useState([]);
    const [ticketTypeInfos, setTicketTypeInfos] = useState([]);

    const [loading, setLoading] = useState(false);
    const [resources, setResources] = useState({});
    const [token] = useState(sessionStorage.getItem("token"));

    const [allowPointZeroForumTicketTypes, setAllowPointZeroForumTicketTypes] = useState([]);

    // fetching resources
    const { language } = useParams();

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    useEffect(() => {
        requestFormSettings();
    }, []);

    useEffect(() => {
        requestResources();
    }, [language]);

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;

        requestOrderInformation();
    }, []);

    const requestFormSettings = () => {
        axios.get(`form/formsettings`).then((res) => {
            setAllowPointZeroForumTicketTypes(res.data.allowPointZeroForumTicketTypes);
        });
    };

    const requestResources = () => {
        axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data.translation);
            })
            .catch((error) => console.log(error.response.data));
    };

    const requestOrderInformation = () => {
        setLoading(true);

        axios
            .get(`${baseUrl}/ShopBasket/Order/${orderId}`)
            .then((res) => {
                setBookedTickets(res.data.tickets);
                setOrder(res.data);
                res.data.tickets.map((t) => requestTicketTypeInfo(t.ticketTypeId));

                setTimeout(() => setLoading(false), 500);
            })
            .catch((error) => {
                console.error(error.response.data);
                navigate(`/${language}/sessiontimeout`);
            });
    };

    const requestTicketTypeInfo = (ticketTypeId) => {
        axios
            .get(`${baseUrl}/TicketType/${ticketTypeId}/Infos`)
            .then((res) => {
                setTicketTypeInfos((current) => [...current, res.data.ticketTypeInfos[0]]);
            })
            .catch((error) => console.log(error.response.data));
    };

    const onInputChange = (e, ticketId) => {

        bookedTickets.forEach(t => {
            if (t.id === ticketId) {
                t[e.target.name] = e.target.value;
            }
        });

        setBookedTickets([...bookedTickets]);
    };

    const handleEventCheckboxChange = (ticketId, eventField, eventValue) => {
        bookedTickets.forEach(t => {
            if (t.id === ticketId) {
                // Toggle the checkbox value
                t[eventField] = t[eventField] === eventValue ? "" : eventValue;
            }
        });

        setBookedTickets([...bookedTickets]);
    };

    const mapTicketsUserData = () => {

        return (
            ticketTypeInfos &&
            ticketTypeInfos.length > 0 &&
            bookedTickets &&
            bookedTickets.length > 0 &&
            bookedTickets.map(
                (bt, index) => (
                    <div key={bt.id} className="mt-4">
                        <div className="row mt-2">
                            <div className="col-md-12">
                                <span className="title-blue">Ticket: {bt.firstname} {bt.lastname}</span>
                            </div>
                        </div>
                        <div className="row mt-1">

                            {/* SwissHacks Closing Ceremony */}
                            <div className="col-md-12 mt-3">
                                <label
                                    className={`d-flex align-items-center mb-2${bt.option4 === resources?.Events1 ? ' selected-interest' : ''}`}
                                    style={{ cursor: "pointer" }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={bt.option4 === resources?.Events1}
                                        onChange={() => handleEventCheckboxChange(bt.id, "option4", resources?.Events1)}
                                        className="d-none"
                                    />
                                    <i className={`bi bi${bt.option4 === resources?.Events1 ? "-check" : ""}-square me-2`}></i>
                                    <div className="d-flex flex-column">
                                        <span className="dark-grey">{resources?.Events1}</span>
                                        <small className={`text-muted ${bt.option4 === resources?.Events1 ? "white" : "blue"}`}>
                                            {resources?.Events1Description}
                                        </small>
                                    </div>
                                </label>
                            </div>

                            {/* FuW Fintech Forum */}
                            <div className="col-md-12 mt-2">
                                <label
                                    className={`d-flex align-items-center mb-2${bt.option5 === resources?.Events2 ? ' selected-interest' : ''}`}
                                    style={{ cursor: "pointer" }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={bt.option5 === resources?.Events2}
                                        onChange={() => handleEventCheckboxChange(bt.id, "option5", resources?.Events2)}
                                        className="d-none"
                                    />
                                    <i className={`bi bi${bt.option5 === resources?.Events2 ? "-check" : ""}-square me-2`}></i>
                                    <div className="d-flex flex-column">
                                        <span className="dark-grey">{resources?.Events2}</span>
                                        <small className={`text-muted ${bt.option5 === resources?.Events2 ? "white" : "blue"}`}>
                                            {resources?.Events2Description}
                                        </small>
                                    </div>
                                </label>
                            </div>

                            {/* SFW Startup Fair */}
                            <div className="col-md-12 mt-2">
                                <label
                                    className={`d-flex align-items-center mb-2${bt.option6 === resources?.Events3 ? ' selected-interest' : ''}`}
                                    style={{ cursor: "pointer" }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={bt.option6 === resources?.Events3}
                                        onChange={() => handleEventCheckboxChange(bt.id, "option6", resources?.Events3)}
                                        className="d-none"
                                    />
                                    <i className={`bi bi${bt.option6 === resources?.Events3 ? "-check" : ""}-square me-2`}></i>
                                    <div className="d-flex flex-column">
                                        <span className="dark-grey">{resources?.Events3}</span>
                                        <small className={`text-muted ${bt.option6 === resources?.Events3 ? "white" : "blue"}`}>
                                            {resources?.Events3Description}
                                        </small>
                                    </div>
                                </label>
                            </div>

                            {/* Swiss Fintech Awards Night */}
                            <div className="col-md-12 mt-2">
                                <label
                                    className={`d-flex align-items-center mb-2${bt.option7 === resources?.Events4 ? ' selected-interest' : ''}`}
                                    style={{ cursor: "pointer" }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={bt.option7 === resources?.Events4}
                                        onChange={() => handleEventCheckboxChange(bt.id, "option7", resources?.Events4)}
                                        className="d-none"
                                    />
                                    <i className={`bi bi${bt.option7 === resources?.Events4 ? "-check" : ""}-square me-2`}></i>
                                    <div className="d-flex flex-column">
                                        <span className="dark-grey">{resources?.Events4}</span>
                                        <small className={`text-muted ${bt.option7 === resources?.Events4 ? "white" : "blue"}`}>
                                            {resources?.Events4Description}
                                        </small>
                                    </div>
                                </label>
                            </div>

                            {/* Fintech Makers Night */}
                            <div className="col-md-12 mt-2">
                                <label
                                    className={`d-flex align-items-center mb-2${bt.option8 === resources?.Events5 ? ' selected-interest' : ''}`}
                                    style={{ cursor: "pointer" }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={bt.option8 === resources?.Events5}
                                        onChange={() => handleEventCheckboxChange(bt.id, "option8", resources?.Events5)}
                                        className="d-none"
                                    />
                                    <i className={`bi bi${bt.option8 === resources?.Events5 ? "-check" : ""}-square me-2`}></i>
                                    <div className="d-flex flex-column">
                                        <span className="dark-grey">{resources?.Events5}</span>
                                        <small className={`text-muted ${bt.option8 === resources?.Events5 ? "white" : "blue"}`}>
                                            {resources?.Events5Description}
                                        </small>
                                    </div>
                                </label>
                            </div>

                            {/* Innovation Tours */}
                            <div className="col-md-12 mt-2">
                                <label
                                    className={`d-flex align-items-center mb-2${bt.option9 === resources?.Events6 ? ' selected-interest' : ''}`}
                                    style={{ cursor: "pointer" }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={bt.option9 === resources?.Events6}
                                        onChange={() => handleEventCheckboxChange(bt.id, "option9", resources?.Events6)}
                                        className="d-none"
                                    />
                                    <i className={`bi bi${bt.option9 === resources?.Events6 ? "-check" : ""}-square me-2`}></i>
                                    <div className="d-flex flex-column">
                                        <span className="dark-grey">{resources?.Events6}</span>
                                        <small className={`text-muted ${bt.option9 === resources?.Events6 ? "white" : "blue"}`}
                                            dangerouslySetInnerHTML={{ __html: resources?.Events6Description }}></small>
                                    </div>
                                </label>
                            </div>

                            {/* Swiss Fintech Week Afterparty */}
                            <div className="col-md-12 mt-2">
                                <label
                                    className={`d-flex align-items-center mb-2${bt.option10 === resources?.Events7 ? ' selected-interest' : ''}`}
                                    style={{ cursor: "pointer" }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={bt.option10 === resources?.Events7}
                                        onChange={() => handleEventCheckboxChange(bt.id, "option10", resources?.Events7)}
                                        className="d-none"
                                    />
                                    <i className={`bi bi${bt.option10 === resources?.Events7 ? "-check" : ""}-square me-2`}></i>
                                    <div className="d-flex flex-column">
                                        <span className="dark-grey">{resources?.Events7}</span>
                                        <small className={`text-muted ${bt.option10 === resources?.Events7 ? "white" : "blue"}`}>
                                            {resources?.Events7Description}
                                        </small>
                                    </div>
                                </label>
                            </div>

                            {/* Point Zero Forum - Only show for specific ticket types */}
                            {allowPointZeroForumTicketTypes.includes(bt.ticketTypeId) && (
                                <div className="col-md-12 mt-2">
                                    <label
                                        className={`d-flex align-items-center mb-2${bt.option11 === resources?.Events8 ? ' selected-interest' : ''}`}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={bt.option11 === resources?.Events8}
                                            onChange={() => handleEventCheckboxChange(bt.id, "option11", resources?.Events8)}
                                            className="d-none"
                                        />
                                        <i className={`bi bi${bt.option11 === resources?.Events8 ? "-check" : ""}-square me-2`}></i>
                                        <div className="d-flex flex-column">
                                            <span className="dark-grey">{resources?.Events8}</span>
                                            <small className={`text-muted ${bt.option11 === resources?.Events8 ? "white" : "blue"}`}>
                                                {resources?.Events8Description}
                                            </small>
                                        </div>
                                    </label>
                                </div>
                            )}

                        </div>
                    </div>
                )
            )
        );
    }

    // validating input fields
    let validatorTicketInputs = 0;

    bookedTickets.forEach(t => {
        if (!((t.option4 || t.option5 || t.option6 || t.option7 || t.option8 ||
            t.option9 || t.option10 || t.option11))) { // At least one event must be selected
            validatorTicketInputs += 1;
        }
    });

    const addDataToTickets = () => {

        //update ticket address
        bookedTickets.forEach((t, key, bookedTickets) => {

            let ticketBody = {
                // Preserve existing participant data from Step30_Participants
                firstname: t.firstname || "",
                name: t.lastname || "",
                function: t.function || "",
                company: t.company || "",
                email: t.email || "",
                mobile: t.mobile || "",
                country: t.country || "",
                option1: t.option1 || "",
                option2: t.option2 || "",
                option3: t.option3 || "",
                // Add event selections from Step40_Events
                option4: t.option4 || "",
                option5: t.option5 || "",
                option6: t.option6 || "",
                option7: t.option7 || "",
                option8: t.option8 || "",
                option9: t.option9 || "",
                option10: t.option10 || "",
                option11: t.option11 || "",
            };

            axios
                .put(`${baseUrl}/Ticket/${t.id}/Address`, ticketBody)
                .then(() => {
                    if (Object.is(bookedTickets.length - 1, key)) {
                        /* redirect to workshops or checkout page on last interation */
                        navigareToWorkshopsOrCheckoutPages();
                    }
                })
                .catch((error) => console.log(error.response.data));
        });
    }

    const navigareToWorkshopsOrCheckoutPages = () => {
        //check if booked ticket are workshop ticket types
        let workshopTicketTypeIds = remarks["WorkshopTicketTypeIds"];

        // Check if any ticket has option5 (FuW Fintech Forum incl. Workshops) selected
        const hasInnovationToursSelected = bookedTickets.some(ticket =>
            ticket.option5 && ticket.option5 !== ""
        );

        // Check if any ticket has a workshop ticket type
        //let hasWorkshopTicketType = false;
        //for (var i = 0; i < bookedTickets.length; i++) {
        //    for (var j = 0; j < workshopTicketTypeIds.length; j++) {
        //        if (bookedTickets[i].ticketTypeId === workshopTicketTypeIds[j]) {
        //            hasWorkshopTicketType = true;
        //            break;
        //        }
        //    }
        //    if (hasWorkshopTicketType) break;
        //}

        // Navigate to workshops only if BOTH conditions are met
        /*if (hasWorkshopTicketType && hasInnovationToursSelected) {*/
        if (hasInnovationToursSelected) {
            navigate(`/${language}/workshops`);
        } else {
            if (order.totalPrice === 0) {
                changePaymentTypeToFree();
            } else {
                navigate(`/${language}/checkout`);
            }
        }
    }

    const changePaymentTypeToFree = () => {
        axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/5`)
            .then(async () => {
                await confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/confirmation/${orderId}`);
            });
    }

    const confirmShopbasketByOrderId = async (orderId) => {
        try {
            const res = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Confirm`);
            return res.data;
        } catch (error) {
            console.error(error)
        }
    };

    return (
        <div>
            {loading ? (
                <>
                    <div className="d-none d-lg-block">
                        <Loading
                            alignment="center"
                            color="#d3d3d3"
                            bgColor="#fff"
                            position="fixed"
                            top="50%"
                            left="50%"
                        />
                    </div>
                    <div className="d-lg-none">
                        <Loading
                            alignment="center"
                            color="#d3d3d3"
                            bgColor="#fff"
                            position="fixed"
                            top="45%"
                            left="45%"
                        />
                    </div>
                </>
            ) : (
                <>
                    <Header />

                    {resources && (
                        <div className="container pt-0 wrapper-smaller">

                            <div className="row mt-5">
                                <div className="col-md-12">
                                    <span className="title">Please select all events you are planning to attend</span><br />
                                    <span className="text-muted">Limited access, save your spot now!</span>
                                </div>
                            </div>

                            {/* user data */}
                            <div className="row">
                                <div className="col-md-7">
                                    {mapTicketsUserData()}
                                </div>
                            </div>


                            {/* next button */}
                            <div className="row mt-5">
                                <div className="col-md-6 text-start">
                                    <button className="btn btn-custom" onClick={() => navigate(-1)}>
                                        {resources._Back}
                                    </button>
                                </div>
                                <div className="col-md-6 text-end">
                                    <button className="btn btn-custom" onClick={addDataToTickets} disabled={validatorTicketInputs > 0}>
                                        {resources._Next}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="container wrapper">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <Footer language={language} />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Step40_Events;